// All flags ship as one lazily loaded chunk instead of one image request per
// country; every CountryFlag shares the same import.
let flagsPromise

export const loadFlags = () => {
  flagsPromise ||= import("country-flag-icons/react/3x2")
  return flagsPromise
}
